module.exports = __webpack_public_path__ + "media/app/img/cocos-logo128-c5815e433bd0e10f59251e15276841f3.png";